module.exports = __webpack_public_path__ + "img/file-upload-pdf-doc-ghosted.61765804.svg";